export enum TicketSpecialOptionValueType {
  Other = '__special_option_value_for_other__',
}
